<div [formGroup]="group" class="row">
  <div *ngIf="showTransferTypeSelect" class="col-md-6 form-group">
    <app-input-select
      [inputData]="attr['transferType']"
      [selectOptions]="transferTypes"
      [bindLabel]="'name'"
      [bindValue]="'value'"
      [formControlName]="'transfer_type_po'"></app-input-select>
  </div>

  <!-- Bank transfer -->
  <ng-container *ngIf="currentType === type.bank">
    <div class="col-md-6 form-group">
      <app-input-select
        [inputData]="attr['bank']"
        [selectOptions]="banks"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [formControl]="bankCtrl"
        (selectionChange)="onBankSelected($event)"></app-input-select>
    </div>
    <ng-container formGroupName="bene_bank_details">
      <div class="col-md-6 form-group">
        <app-input-select
          [inputData]="attr['bankBranch']"
          [selectOptions]="branches"
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [formControlName]="'bank_branch_id'"
          (selectionChange)="onBranchSelected($event)"></app-input-select>
      </div>
      <div class="col-md-6 form-group">
        <app-input-template
          [inputData]="attr['bankAccountNumber']"
          [formControlName]="'bank_account_number'"></app-input-template>
      </div>
      <div class="col-md-6 form-group">
        <app-input-template
          [inputData]="attr['bankAccountName']"
          [formControlName]="'bank_account_name'"></app-input-template>
      </div>
      <div class="col-md-6 form-group">
        <app-input-select
          [inputData]="attr['bankAccountType']"
          [selectOptions]="bankAccountTypes"
          [bindLabel]="'name'"
          [bindValue]="'value'"
          [formControlName]="'bank_account_type'"></app-input-select>
      </div>
      <div class="col-md-6 form-group">
        <app-input-template
          [inputData]="attr['bankIfscCode']"
          [formControlName]="'bank_ifsc_code'"></app-input-template>
      </div>
      <div class="col-md-6 form-group">
        <app-input-template
          [inputData]="attr['bankAdditionalDetails']"
          [formControlName]="'bank_additional_details'"></app-input-template>
      </div>
    </ng-container>
  </ng-container>

  <!-- Cash pickup -->
  <ng-container *ngIf="currentType === type.cashPickup">
    <div class="col-md-6 form-group">
      <app-input-select
        [inputData]="attr['collectionState']"
        [selectOptions]="collectionStates"
        [bindLabel]="'name'"
        [bindValue]="'value'"
        [formControlName]="'collection_point_state'"
        (selectionChange)="onCollectionStateSelected($event)"></app-input-select>
    </div>
    <div class="col-md-6 form-group">
      <app-input-select
        [inputData]="attr['collectionCity']"
        [selectOptions]="collectionCities"
        [bindLabel]="'name'"
        [bindValue]="'value'"
        [formControlName]="'collection_point_city'"
        (selectionChange)="onCollectionCitySelected($event)"></app-input-select>
    </div>
    <div class="col-md-6 form-group">
      <app-input-select
        [inputData]="attr['collectionPoint']"
        [selectOptions]="collectionPoints"
        [bindLabel]="'name'"
        [bindValue]="'id'"
        [formControlName]="'collection_point_id'"
        (selectionChange)="onCollectionPointSelected($event)"></app-input-select>
    </div>
  </ng-container>

  <!-- Mobile transfer -->
  <ng-container *ngIf="currentType === type.mobile">
    <div class="col-md-6 form-group">
      <app-input-select
        [inputData]="attr['mobileNetwork']"
        [selectOptions]="mobileOperators"
        [bindLabel]="'name'"
        [bindValue]="'mobile_network_id'"
        [formControlName]="'mobile_transfer_network_id'"
        (selectionChange)="onMobileNetworkSelected($event)"></app-input-select>
    </div>
    <div class="col-md-6 form-group">
      <app-input-template
        [inputData]="attr['mobileNumber']"
        [formControlName]="'mobile_transfer_number'"></app-input-template>
    </div>
  </ng-container>
</div>
